/* eslint-env browser */
import * as React from 'react'
import TrackVisibility from 'react-on-screen'
import ReactPlayer from 'react-player'

import { getCDNUrl } from '../../../../../../shared/services/media-helper'
import withTranslator from '../TranslatorProvider'

const PropTypes = require('prop-types')
const classNames = require('classnames')

const ShareModal = require('../Modals/ShareModal')
const LikeButton = require('../like-button')
const UnitsService = require('../../../../client/clientjs/services/units-service')
const EmptyImagesGenerator = require('../../../../../../shared/services/empty-images-generator')
const StringUtilities = require('../../../../../../shared/services/string-utilities')
const CommentsList = require('../Comments/CommentsList')
const MediaCarousel = require('../Catches/MediaCarousel')
const WeatherData = require('../Weather/WeatherData')
const GearItem = require('../Gear/GearItem')
const CatchesGrid = require('../CatchesGrid/Grid')

class FullCatch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalVisible: false,
      modalOpts: {},
    }
    this.onClickShare = this.onClickShare.bind(this)
    this.onHideModal = this.onHideModal.bind(this)
  }

  onClickShare(modalOpts) {
    this.setState({ isModalVisible: true, modalOpts })
  }

  onHideModal() {
    this.setState({ isModalVisible: false })
  }

  render() {
    const { isModalVisible, modalOpts } = this.state
    const {
      fishCatch,
      isLoggedIn,
      locale,
      userSettings,
      translate,
      locationLabels,
      commentsCount,
      latestComments,
      currentUserLike,
      otherCatches,
      inContests,
      host,
    } = this.props
    const { creator } = fishCatch

    let creatorProfilePictureUrl = creator.fbProfilePictureUrl
    if (creator.profilePicture) {
      creatorProfilePictureUrl = getCDNUrl(creator.profilePicture, 'extra_small')
    }
    if (!creatorProfilePictureUrl) {
      creatorProfilePictureUrl = EmptyImagesGenerator.getUserPlaceholder({ userId: creator.id })
    }

    let catchMethodName = '--'
    if (fishCatch.catchMethodCustomName) {
      catchMethodName = fishCatch.catchMethodCustomName
    } else if (fishCatch.catchMethod) {
      catchMethodName = (fishCatch.catchMethod.names[0] || {}).value
    }
    if (!catchMethodName) {
      catchMethodName = '--'
    }

    const isTopCatch = (fishCatch.flags || []).some(elt => elt.flag === 'TOP_CATCH')
    const topCatchReasonIndex = (StringUtilities.hashCode(fishCatch.id) || 0) % 3

    return (
      <div className="columns is-multiline has-background-white large-shadow-left">
        <div className="column is-7">
          <div style={{ position: 'relative' }}>
            <MediaCarousel medias={fishCatch.medias} imageHeight="50vh" isCover={false} />
            {fishCatch.videos.length > 0 && (
              <TrackVisibility
                style={{
                  maxHeight: '50%',
                  maxWidth: '50%',
                  height: '50%',
                  width: '50%',
                  padding: 0,
                  position: 'absolute',
                  bottom: '1rem',
                  right: '1rem',
                }}
              >
                {({ isVisible }) => (
                  <ReactPlayer
                    className="react-player small-shadow-top-left large-shadow-top-left-on-hover is-rounded"
                    volume={0}
                    muted
                    loop
                    pip
                    width="auto"
                    height="auto"
                    style={{
                      maxHeight: '100%',
                      maxWidth: '100%',
                      position: 'absolute',
                      top: 0,
                      bottom: 0,
                      right: 0,
                    }}
                    playing={isVisible}
                    url={fishCatch.videos[0].url}
                  />
                )}
              </TrackVisibility>
            )}
          </div>
          <nav className="level is-mobile has-padding-small" style={{ marginBottom: 0, justifyContent: 'center' }}>
            <div className="level-item has-text-centered" style={{ flexGrow: 0 }}>
              <LikeButton
                locale={locale}
                likeable="fishCatch"
                likeableId={fishCatch.id}
                likesNumber={(fishCatch.aggregDatas || {}).likesCount || 0}
                isLoggedIn={isLoggedIn}
                currentUserLike={currentUserLike}
                size="small"
              />
            </div>
            <div className="level-item has-text-centered is-size-7" style={{ flexGrow: 0 }}>
              <span className="icon has-text-ctaGreen">
                <i className="fas fa-comments" />
              </span>
              <span className="has-text-primary-blue has-text-weight-bold">{commentsCount}</span>
            </div>
            <div className="level-item has-text-centered" style={{ flexGrow: 0 }}>
              <button
                className="button is-white is-small"
                type="button"
                onClick={() =>
                  this.onClickShare({ shareableLink: `/users/${fishCatch.createdBy}/catches/${fishCatch.id}` })
                }
              >
                <span className="icon has-text-ctaGreen">
                  <i className="fas fa-share" />
                </span>
                <span className="has-text-primary-blue has-text-weight-bold">{translate('share')}</span>
              </button>
            </div>
          </nav>
          {(inContests.length > 0 || isTopCatch) && [
            <hr key="flags-divider" className="has-margin-top-zero has-margin-bottom-xsmall is-hidden-mobile" />,
            <div key="flags-table" className="columns is-multiline has-padding-top-small">
              {isTopCatch && (
                <div className="column is-6">
                  <div className="columns is-mobile is-size-7">
                    <div className="column is-3 is-vertical-centered has-text-right">
                      <img
                        alt={translate('topCatch.title')}
                        src="https://res.cloudinary.com/fishfriender/image/upload/v1533810175/gcloud_storage_static/statics/stamps/top_catch.png"
                        style={{ width: 80, maxWidth: '100%', alignSelf: 'flex-end' }}
                      />
                    </div>
                    <div className="column is-vertical-centered">
                      <span className="has-text-weight-bold">{translate('topCatch.title')}</span>
                      <small>{translate(`topCatch.reasons.${topCatchReasonIndex}`)}</small>
                    </div>
                  </div>
                </div>
              )}
              {inContests.map(elt => (
                <div key={elt.id} className="column is-6 is-size-7">
                  <div className="columns is-mobile">
                    <div className="column is-3 is-vertical-centered has-text-right">
                      {elt.watermark && (
                        <img
                          alt={elt.name}
                          src={getCDNUrl(elt.watermark, 'small')}
                          style={{ width: 80, maxWidth: '100%', alignSelf: 'flex-end' }}
                        />
                      )}
                    </div>
                    <div className="column is-vertical-centered">
                      <span>
                        {translate('contests.catchInContest')}
                        &nbsp;
                        <a href={`/contests/${elt.seoName}`} target="_blank" rel="noopener noreferrer">
                          {elt.name}
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>,
          ]}
          <hr className="has-margin-top-zero has-margin-bottom-xsmall is-hidden-mobile" />
          <div className="has-padding-vertical-xsmall has-padding-horizontal-small is-hidden-mobile">
            <CommentsList
              locale={locale}
              comments={latestComments || []}
              totalCommentsCount={Number.parseInt(commentsCount, 10) || 0}
              commentable="fishCatch"
              commentableId={fishCatch.id}
              isLoggedIn={isLoggedIn}
              opCreatorId={fishCatch.createdBy}
            />
          </div>
        </div>
        <div className="column is-5">
          <div className="media">
            <div className="media-left has-margin-xsmall">
              <figure className="image is-32x32-mobile is-64x64-tablet is-square">
                <img
                  src={creatorProfilePictureUrl}
                  alt={`${creator.firstName} ${creator.lastName}`}
                  className="has-object-fit-cover lazyload is-rounded has-border-white"
                />
              </figure>
            </div>
            <div className="media-content is-self-centered is-size-7">
              <p>
                <a href={`/users/${creator.id}`} className="has-text-weight-bold">
                  {`${creator.firstName} ${creator.lastName}`}
                </a>
                <br />
                {fishCatch.dateMoment}
              </p>
            </div>
          </div>
          {fishCatch.observations && <p className="content is-size-7">{fishCatch.observations}</p>}
          <div className="catch-fish-card has-padding-small has-text-centered" style={{ backgroundColor: '#E8F0F2' }}>
            {fishCatch.speciesCustomName && (
              <h1 className="has-text-centered  is-size-4 is-size-6-mobile has-text-weight-bold">
                {fishCatch.speciesCustomName}
              </h1>
            )}
            {!fishCatch.speciesCustomName && fishCatch.fish && (
              <h1 className="has-text-centered is-size-4 is-size-6-mobile has-text-weight-bold">
                <a href={`/fish/${fishCatch.fish.seoName}`} target="_blank" rel="noopener noreferrer">
                  {((fishCatch.fish.names || [])[0] || {}).value}
                </a>
              </h1>
            )}
            {fishCatch.quantity > 1 && (
              <small>{translate('catchItem.fishQuantity', { quantity: fishCatch.quantity })}</small>
            )}
            <nav className="level is-mobile is-size-6 is-size-8-mobile" style={{ marginBottom: 0 }}>
              <div className="level-item has-text-centered">
                <span className="icon has-text-primary-blue">
                  <i className="fas fa-weight-hanging" />
                </span>
                <span className="has-text-weight-bold">
                  {fishCatch.weight > 0
                    ? UnitsService.massInUserSettings(fishCatch.weight, locale, userSettings, { withUnit: true })
                    : '--'}
                </span>
              </div>
              <div className="level-item has-text-centered">
                <span className="icon has-text-primary-blue">
                  <i className="fas fa-ruler-combined" />
                </span>
                <span className="has-text-weight-bold">
                  {fishCatch.size > 0
                    ? UnitsService.sizeInUserSettings(fishCatch.size, locale, userSettings, { withUnit: true })
                    : '--'}
                </span>
              </div>
              {typeof fishCatch.released !== 'undefined' && fishCatch.released !== null && (
                <div className="level-item has-text-centered">
                  <span className="icon has-text-primary-blue">
                    <i
                      className={classNames('fas', {
                        'fa-heart': !!fishCatch.released,
                        'fa-utensils': !fishCatch.released,
                      })}
                    />
                  </span>
                  <span className="has-text-weight-bold">
                    {fishCatch.released
                      ? translate('catchItem.releasedStatus.true')
                      : translate('catchItem.releasedStatus.false')}
                  </span>
                </div>
              )}
            </nav>
            <div className="is-divider is-link has-margin-vertical-small" />
            <nav className="level is-mobile">
              <div className="level-item has-text-centered">
                <div>
                  <p className="heading">{translate('catchItem.catchMethod')}</p>
                  <p className="title is-6 is-size-8-mobile">{catchMethodName}</p>
                </div>
              </div>
              <div className="level-item has-text-centered">
                <div>
                  <p className="heading">{translate('catchItem.fightingTime')}</p>
                  <p className="title is-6">
                    {fishCatch.fightingTime > 0 ? `${Math.round(fishCatch.fightingTime)}min` : '--'}
                  </p>
                </div>
              </div>
            </nav>
          </div>
          {fishCatch.tackleBox.length + fishCatch.customProducts.length > 0 && (
            <div className="has-padding-top-small">
              <h2 className="has-text-weight-bold has-text-primary-blue">{translate('catchItem.tackleBox')}</h2>
              <div className="columns is-mobile is-multiline">
                {fishCatch.tackleBox.map(elt => (
                  <div key={`product-article-${elt.productArticleId}`} className="column is-4">
                    <GearItem gear={elt} productCategory={elt.productCategory} />
                  </div>
                ))}
                {fishCatch.customProducts.map(elt => (
                  <div key={`custom-product-${elt.id}`} className="column is-4">
                    <GearItem gear={{ isCustomProduct: true, ...elt }} productCategory={elt.productCategory} />
                  </div>
                ))}
              </div>
            </div>
          )}
          {locationLabels.staticMapUrl && (
            <div className="has-padding-top-small">
              <h2 className="has-text-weight-bold has-text-primary-blue">{translate('catchItem.location')}</h2>
              {locationLabels.staticMapUrl && (
                <figure className="image is-3by1">
                  <img alt="" src={locationLabels.staticMapUrl} className="has-object-fit-cover" />
                </figure>
              )}
              {locationLabels.precise && (
                <div className="is-size-8 has-text-right">
                  {locationLabels.precise}
                  <span className="icon">
                    <i id="precise-location-icon" className="text-primary fas fa-map-marker-alt" />
                  </span>
                </div>
              )}
              {locationLabels.around && <div className="is-size-8 has-text-right">{locationLabels.around}</div>}
            </div>
          )}
          {fishCatch.weatherData && (
            <div className="has-padding-top-small">
              <h2 className="has-text-weight-bold has-text-primary-blue">{translate('catchItem.weather')}</h2>
              <WeatherData weatherData={fishCatch.weatherData} locale={locale} userSettings={userSettings} />
            </div>
          )}
          <div className="is-hidden-tablet">
            <hr className="has-margin-top-zero has-margin-bottom-xsmall" />
            <div className="has-padding-vertical-xsmall has-padding-horizontal-small">
              <CommentsList
                locale={locale}
                comments={latestComments || []}
                totalCommentsCount={Number.parseInt(commentsCount, 10) || 0}
                commentable="fishCatch"
                commentableId={fishCatch.id}
                isLoggedIn={isLoggedIn}
                opCreatorId={fishCatch.createdBy}
                mostRecentOnTop
              />
            </div>
          </div>
          {otherCatches.length > 0 && (
            <div className="has-padding-top-small">
              <h2 className="has-text-weight-bold has-text-primary-blue">
                {translate('catchItem.otherCatches', { creatorName: creator.firstName })}
              </h2>
              <div className="has-padding-top-small">
                <CatchesGrid
                  userSettings={userSettings}
                  locale={locale}
                  isLoggedIn={isLoggedIn}
                  catches={otherCatches}
                  simpleGrid={false}
                  customItemClassName="is-4 is-size-8 has-padding-small"
                  displayLikes={false}
                />
              </div>
            </div>
          )}
        </div>
        <ShareModal isActive={isModalVisible} onHide={this.onHideModal} host={host} {...modalOpts} />
      </div>
    )
  }
}

FullCatch.propTypes = {
  fishCatch: PropTypes.object.isRequired,
  locationLabels: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool,
  translate: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  userSettings: PropTypes.object,
  latestComments: PropTypes.array.isRequired,
  commentsCount: PropTypes.number.isRequired,
  currentUserLike: PropTypes.object,
  otherCatches: PropTypes.array,
  inContests: PropTypes.array,
  host: PropTypes.string.isRequired,
}

FullCatch.defaultProps = {
  isLoggedIn: false,
  userSettings: {},
  currentUserLike: null,
  otherCatches: [],
  inContests: [],
}

module.exports = withTranslator(FullCatch)
